export default __webpack_public_path__ + "images/818a6f8d2ebcd320df634ee2cf24582d.png";